export default __webpack_public_path__ + "static/media/data-analyst-career-guide-and-interview-preparation.3353470a.png";